
import {

    atom,

} from 'recoil';

const krilBalState = atom({
    key: 'krilbal', // unique ID (with respect to other atoms/selectors)
    default: "0", // default value (aka initial value)
});

export default krilBalState;